import { useUser } from 'app/utils'

export function AuthSuper(props: any) {
  let user = useUser()
  if (!user) return <></>
  if (user.type === `super`) {
    return <>{props.children}</>
  } else {
    return <></>
  }
}
